import { useEffect } from "react";

export default function SEO({ title, description }) {
  useEffect(() => {
    const siteName = "Hoofcare";
    let fullTitle = "";

    if (!title || title === "Forside" || title === siteName) {
      fullTitle = "Hoofcare - Certificeret hovtrimmer & naturlig hovtrimning";
    } else if (title.includes(siteName)) {
      fullTitle = title;
    } else {
      fullTitle = `${title} | Hoofcare - Certificeret Hovtrimmer`;
    }

    document.title = fullTitle;

    const defaultDesc =
      "Certificeret ISNHCP hovtrimmer Metteline Hjorth tilbyder skånsom & naturlig hovtrimning i Lemvig, Struer og hele Jylland. Få sunde, stærke hove.";
    const metaDescription = description || defaultDesc;

    const setMetaTag = (selector, attrName, attrVal, content) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attrName, attrVal);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    // Meta Description
    setMetaTag('meta[name="description"]', 'name', 'description', metaDescription);

    // Open Graph
    setMetaTag('meta[property="og:title"]', 'property', 'og:title', fullTitle);
    setMetaTag('meta[property="og:description"]', 'property', 'og:description', metaDescription);
    setMetaTag('meta[property="og:type"]', 'property', 'og:type', 'website');
    setMetaTag('meta[property="og:site_name"]', 'property', 'og:site_name', siteName);

    // Twitter Card
    setMetaTag('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
    setMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', fullTitle);
    setMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', metaDescription);
  }, [title, description]);

  return null;
}
